import { render, staticRenderFns } from "./GlobalStatistics.vue?vue&type=template&id=f9fd45a8&"
import script from "./GlobalStatistics.vue?vue&type=script&lang=js&"
export * from "./GlobalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GlobalStatistics.vue?vue&type=style&index=0&id=f9fd45a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports